import { useContext } from 'react'
import Modal from 'src/components/UI/CustomUI/molecules/Modal'
import { ContractorsContext } from '../context'
import { dispatchTypes, MODAL_TYPE } from '../context/types'
import AddContractor from './AddContractor'
import ConfirmDeleteContractor from './ConfirmDeleteContractor'
import EditContractor from './EditContractor'

const ContractorsModal = () => {
    const { state: { modalType, modalOpen }, dispatch: dispatchContext } = useContext(ContractorsContext)
    const handleClose = () => {
        dispatchContext({ type: dispatchTypes.CLOSE_MODAL, payload: null })
    }

    const getTitle = () => {
        switch (modalType) {
            case MODAL_TYPE.CREATE:
                return "Add New Contractor"
            case MODAL_TYPE.EDIT:
                return "Edit Contractor"
            case MODAL_TYPE.DELETE_COMPANY:
                return "You are going to delete the Contractor:"
            default:
                return 'Contractor'
        }
    }

    const getContent = () => {
        switch (modalType) {
            case MODAL_TYPE.CREATE:
                return <AddContractor />
            case MODAL_TYPE.EDIT:
                return <EditContractor />
            case MODAL_TYPE.DELETE_COMPANY:
                return <ConfirmDeleteContractor />
            default:
                return 'Contractor'
        }
    }

    const getSize = () => {
        switch (modalType) {
            case MODAL_TYPE.CREATE:
                return 'md'
            case MODAL_TYPE.EDIT:
                return 'md'
            case MODAL_TYPE.DELETE_COMPANY:
                return 'sm'
            default:
                return 'md'
        }
    }

    return (
        <Modal
            open={modalOpen}
            setOpen={() => { }}
            onClose={handleClose}
            showClose={true}
            size={getSize()}
            title={getTitle()}
        >
            {getContent()}
        </Modal>
    )
}

export default ContractorsModal